import { TopAdsFiltersProps } from '../../types';
import TopAdsFiltersView from './TopAdsFilters.View';

const TopAdsFilters = (props: TopAdsFiltersProps) => <TopAdsFiltersView {...props} />;

export default TopAdsFilters;
